
import { call, put, select } from "redux-saga/effects";
import { updateSettings, updateOpeningBalanceExists } from "../store/settings";
import { getBranch } from "../store/user/selectors";
import { API_URLS } from "../resources/constants";
import { formQueryString } from '../resources/functions'
import {CallApi} from './callApi'

/*export function* fetchSettings(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.SETTINGS.FETCH_DETAILS  + '?' + formQueryString(payload);
    let result = yield call(CallApi.GET, url,{},true);
    
    yield put(updateAccounting(result.data.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}*/

export function* updateAccountingSettings(action: any): any {
  try {
    const payload = action.payload;
    const {params, ...queryString} = payload;
    const url = API_URLS.SETTINGS.UPDATE_ACCOUNTING  + '?' + formQueryString(queryString);
    let result = yield call(CallApi.PUT, url, params,true);
    
    // yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* updateSalesSettings(action: any): any {
  try {
    const payload = action.payload;
    const {params, ...queryString} = payload;
    const url = API_URLS.SETTINGS.UPDATE_SALES  + '?' + formQueryString(queryString);
    let result = yield call(CallApi.PUT, url, params,true);
    // yield put(updateUser(result.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* fetchAccountSettings(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.SETTINGS.FETCH_ACCOUNT_DETAILS  + '?' + formQueryString(payload);
    let result = yield call(CallApi.GET, url,{},true);
    // The selected activity may have changed while this request was in flight.
    const branch = yield select(getBranch);
    if (Number(branch?.id) !== Number(payload.branch_id)) return;

    const accountSettings = result.data.data.user_account_settings || {};
    // A new activity can have no settings row yet. Retain the request's
    // activity identity so its empty defaults are not mistaken for stale data.
    yield put(updateSettings({
      ...result.data.data,
      user_account_settings: Object.keys(accountSettings).length === 0
        ? { location_branch_id: payload.branch_id }
        : accountSettings,
    }));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}

export function* updateTolatestGl(action: any): any {
  try {
    const payload = action.payload;
    const url = API_URLS.SETTINGS.UPGRADE_TO_LATEST_GL  + '?' + formQueryString(payload);
    let result = yield call(CallApi.POST, url,{},true);
    yield put(updateOpeningBalanceExists(result.data.data));
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e)
  }
}
